import React, { useEffect, useMemo, useState } from 'react';
import styles from './Grid.module.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const shuffle = <T,>(array: T[]): T[] => {
    return [...array].sort(() => Math.random() - 0.5);
};


export type Products = {
    ID: number;
    SubcategoryID: number;
    Name: string;
    MainImage: string;
    ImageList: Text;
    mostSold: number;
}

export type GridProps = {
    setFilterProduct: React.Dispatch<React.SetStateAction<number | null>>;
    filterProduct: number | null;
}

const Grid = (props: GridProps) => {
    const navigate = useNavigate();

    const [products, setProducts] = useState<Products[]>([]);
    const randomizedItems = useMemo(() => shuffle(products), [products]);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                if (props.filterProduct === null) {
                    navigate("/");
                } else {
                    const [products] = await Promise.all([
                        axios.get("https://sazuli.pt/api/products", { params: { categoryId: props.filterProduct } }),
                    ]);
                    setProducts(products.data);
                }
            } catch (err) {
                console.error("Data fetch error:", err);
            }
        };
        fetchAll();
    }, [props.filterProduct]);

    const createSlug = (id: number, name: string) => {
        return `${id}-${name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    };

    const selectProduct = (id: number, name: string) => {
        const slug = createSlug(id, name);
        navigate(`/produtos/${slug}`);
    }

    return (
        <main className={styles.main}>
            <div className={styles.gallery}>
                {randomizedItems.map((item) => (
                    <figure key={item.ID} onClick={() => selectProduct(item.ID, item.Name)}>
                        <img
                            src={
                                item.MainImage
                                    ? `https://sazuli.pt/uploads/${item.MainImage}`
                                    : './assets/images/placeholder_image.png'
                            }
                            alt={item.Name}
                        />
                        <figcaption>
                            <h3>{item.Name}</h3>
                        </figcaption>
                    </figure>
                ))}
            </div>
        </main>
    );
};

export default Grid;